import React from 'react'
import cx from 'classnames'

import s from './base.scss'


const Line = ({ className }) => <div className={cx(s.line, className)} />


export default Line
